import React from 'react'
import { IoClose } from "react-icons/io5";

function Modal({ showModal, setShowModal, children }) {
    return (
        <div>{showModal && (
            <div className="modal show d-block" tabIndex={-1}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                Add/Edit Driver
                            </h5>
                            <button
                                type="button"
                                // className="btn-close"
                                onClick={() => setShowModal(false)}
                            ><IoClose size={24} /></button>
                        </div>

                        <div className="modal-body">
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        )}
        </div>
    )
}

export default Modal